import { c as _c } from "react/compiler-runtime";
import type React from 'react';
import { ToastProvider } from '../../components/toast';
import ConfirmationDialogProvider from '../confirmation-dialog-provider';
export type BootstrapProps = {
  children: React.ReactNode;
};

// Flags sprite CSS loaded from CDN
// See CSP documentation in middleware.page.ts for security considerations
const FLAGS_CSS_URL = 'https://cdn.jsdelivr.net/gh/rafaelmotta/footprint-flags/sprite.css';
const DesignSystemProvider = t0 => {
  const $ = _c(7);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    t1 = <ConfirmationDialogProvider><ToastProvider>{children}</ToastProvider></ConfirmationDialogProvider>;
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div id="footprint-portal" />;
    t3 = <div id="footprint-toast-portal" />;
    t4 = process.env.NODE_ENV !== "test" && <link rel="stylesheet" href={FLAGS_CSS_URL} />;
    $[2] = t2;
    $[3] = t3;
    $[4] = t4;
  } else {
    t2 = $[2];
    t3 = $[3];
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t1) {
    t5 = <>{t1}{t2}{t3}{t4}</>;
    $[5] = t1;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  return t5;
};
export default DesignSystemProvider;